import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { bkdp } from "../theme";

type EmptyStateProps = {
  eyebrow?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
};

export function EmptyState({
  eyebrow = "No Data",
  title,
  description,
  action
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        px: { xs: 4, md: 6 },
        py: { xs: 5, md: 7 },
        textAlign: "center",
        backgroundColor: bkdp.white,
        border: `1.5px solid ${bkdp.greyLight}`,
        borderRadius: "10px"
      }}
    >
      {eyebrow && (
        <Typography variant="overline" sx={{ color: bkdp.signalBlue, display: "block", mb: 1.5 }}>
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h6" sx={{ color: bkdp.deepNavy }}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{
            mt: 1.5,
            color: bkdp.textBody,
            maxWidth: 480,
            mx: "auto"
          }}
        >
          {description}
        </Typography>
      )}
      {action ? <Box sx={{ mt: 3.5 }}>{action}</Box> : null}
    </Box>
  );
}
